<app-driveb-master-detail-view
  [closeTrigger]="closeTrigger"
  [useDialog]="useDialog"
  [useResizeHandle]="useResizeHandle"
  [masterViewMinSize]="masterViewMinSize"
  [detailViewMinSize]="detailViewMinSize"
  [(detailViewSize)]="detailViewSize"
  [useSlideoverSidebarMode]="useSlideoverSidebarMode"
>
  <app-driveb-master-view>
    <ng-content></ng-content>
  </app-driveb-master-view>

  <app-driveb-detail-view *ngIf="withDetailView" [isPadded]="true">
    <router-outlet></router-outlet>
  </app-driveb-detail-view>
</app-driveb-master-detail-view>
